export default __webpack_public_path__ + "static/media/PrioritiesPm.0d9588a7.png";